'use strict';
/*
 * Event Service.
 */

/**
 * REST CLIENT PER WS SOURCE
 */
//module.exports = ('sourceService', ['$resource', 'MAIN_CONFIG', function ($resource, MAIN_CONFIG) {
module.exports = ['$rootScope', '$resource', function ($rootScope, $resource) {
        
        //var mainConfig=$rootScope.configs.ngDroAstralSituationRecordMainConfig;
        var mainConfig = global.ngDroAstralSituationRecordMainConfig;
        var baseEndPointUrl = mainConfig.ApiUrl;
        var sourceEndPointUrl = baseEndPointUrl + 'source/';

        return $resource(baseEndPointUrl, {},
                {
                    'getAll': {
                        method: 'GET',
                        url: sourceEndPointUrl,
                        withCredentials: true,
                        params: {
                            page: '@page',
                            size: '@size',
                            sort: '@sort'
                        }
                    }, 'get': {
                        method: 'GET',
                        url: sourceEndPointUrl + '/:id',
                        withCredentials: true,
                        params: {
                            id: '@id'
                        }
                    },
                    'create': {
                        method: 'POST',
                        url: sourceEndPointUrl,
                        withCredentials: true,
                        transformRequest: function (data) {
                            var json = angular.toJson(data);
                            return json;
                        }
                    },
                    'update': {
                        method: 'PUT',
                        url: sourceEndPointUrl,
                        withCredentials: true,
                        transformRequest: function (data) {
                            var json = angular.toJson(data);
                            return json;
                        }
                    },
                    'delete': {
                        method: 'DELETE',
                        url: sourceEndPointUrl+'/:id',
                        withCredentials: true,
                        params: {
                            id: '@id'
                        }                        
                    }
                });
    }];




//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/services/sourceService.js
// module id = 255
// module chunks = 0